import React from 'react';
import { UserAgentMessage } from './UserAgentMessage';
import { ButtonWithText } from '../../components/atoms/Buttons/ButtonWithText';

export const MESSAGES = {
  error: {
    csv: (nom): string =>
      "Erreur lors de l'ajout de : " +
      nom +
      ", vérifiez que les entêtes n'aient pas été modifié, et que le mail de l'élève soit unique",
    addUser: (nom: string, index: number) => {
      if (nom)
        return (
          "Erreur dans la création de l'utilisateur : " +
          nom +
          ', veuillez réessayer'
        );
      return (
        'Utilisateur n°' +
        index +
        ' ' +
        'Erreur dans le format du fichier, vérifiez les entêtes et assurez vous que toutes les cases soient remplis'
      );
    },
    mailExiste:
      "Erreur dans la création de l'utilisateur, un utilisateur existe déjà avec cette adresse mail.",
    mailExisteUpdate:
      "Impossible de mettre à jour l'adrese mail. Un utilisateur existe déjà avec cette adresse mail.",
    tropErreurrlogin: (
      <>
        Pour vous connecter, vous devez saisir les informations{' '}
        <b>communiquées par votre professeur(e) :</b>
        <br />
        <p>
          - IDENTIFIANT : adresse mail (e-mail de PREMIERE connexion finissant
          par @changez-pour-votre-mail.monmail) ou nom d'utilisateur (exemple
          "jules5498")
          <br />
          - MOT DE PASSE
          <br />
          <br />
          Si votre professeur(e) ne vous a pas communiqué ces informations,{' '}
          <b>vous ne pouvez pas vous connecter à l'application</b> ! Merci de
          les lui demander.
          <br />
          <br />
          Vous pourrez changer le mot de passe de première connexion et
          l'adresse e-mail dans votre compte.
          <br />
          <br />
          Si vous n'arrivez pas à vous connecter, veuillez renouveler votre mot
          de passe en cliquant sur le bouton ci-dessous.
          <br />
          <br />
          Si le problème persiste après renouvellement du mot de passe, envoyez
          un mail à contact@france-challenges.com en précisant : <br />- nom
          d'utilisateur <br />- e-mail <br />- heure et jour de connexion <br />
          - première connexion ?
        </p>
      </>
    ),
    session:
      'Votre session à expiré, merci de recharger la page et de vous re-identifier. Si le problème persiste, contactez-nous',
    pedagogie:
      'Erreur dans la récupération des éléments pédagogiques, veuillez recharger la page',
    ressource:
      'Erreur dans la récupération des ressources, veuillez recharger la page',
    createClasse: {
      dateMin: 'Le challenge ne peut commencer avant le 4 septembre.',
      dateMax:
        "Pour fixer une date de fin des ventes postérieure au 12 novembre, il est nécessaire, au préalable, d'obtenir l'accord de France Challenges."
    },
    password:
      "Une erreur est survenue lors du changement du mot de passe, celui-ci n'a pas été modifié. Veuillez recharger la page et recommencer",
    useragent: {
      message: <UserAgentMessage />,
      title: 'Utilisez de préférence CHROME ou MOZILLA (SAFARI pour IOS)',
      btnText: (
        <ButtonWithText
          content={'Je souhaite continuer avec ce navigateur'}
          onClick={null}
        />
      )
    }
  },
  sucess: {
    addUser: (nom): string => "L'utilisateur : " + nom + ' a bien été créé ✅',
    addUsers: 'Les utilisateurs ont bien été créés ✅'
  }
};
